import { copyFor } from 'config';

const getClientError = copyFor('errors.client');

interface Variables {
  firstName?: string;
  lastName?: string;
  firstNameError?: string;
  lastNameError?: string;
}

interface Params {
  setVariables: (variables: Variables) => void;
  variables: Variables;
}

export const validateForm = ({ setVariables, variables }: Params) => {
  const { firstName, lastName } = variables;
  const variablesUpdate: Variables = {};
  if (!firstName)
    variablesUpdate.firstNameError = getClientError('firstNameBlank');
  if (!lastName)
    variablesUpdate.lastNameError = getClientError('lastNameBlank');
  if (Object.keys(variablesUpdate).length) {
    setVariables({ ...variables, ...variablesUpdate });
    return false;
  }
  return true;
};
